import React from 'react';
import Reflux from 'reflux';

import GongqiFormItem from './GongqiFormItem';
import FormItemTabPage from './FormItemTabPage';
import FormItemUtil from '../utils/FormItemUtil';
import {VerticalSplitterStore} from '../stores/ResizeStore';
import {CmdUpdateControlLabelStore,SwitchTabPageStore} from '../stores/CmdTypeStore';
import {PopUpDomReadySotre} from '../stores/DomStores';
import UtilActions from '../actions/UtilActions';
require("../styles/FormItemTabStyle.css");

class FormItemTab extends GongqiFormItem
{

	constructor(props) 
	{
		super(props);
		let index = this.props.initSelectIndex?this.props.initSelectIndex:0;
		
		this.state = {indexes:[index],currentIndex:index,unVisiblePages:this.props.unVisiblePages,
			visible:this.props.controlVisible,hideInVisible:this.props.hideInVisible};
		this.unsubscribeVerticalSplitterStore = VerticalSplitterStore.listen(this.onVerticalSplitterReisze.bind(this));
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		if(!this.props.forLookup)
			this.unsubscribeSwitchTabPageStore = SwitchTabPageStore.listen(this.onSwitchTabPage.bind(this));
		if(window.isPopUp || this.props.forLookup)
		{
			this.unsubscribePopUpDomReadySotre = PopUpDomReadySotre.listen(this.onPopUpDomReady.bind(this))
		}
	}

	onPopUpDomReady()
	{
		//$(this.containerComponent).css("flex")
	}

	onVerticalSplitterReisze(_id,addon)
	{
		if(_id != this.props.xml.id)
			return;
		this.pageHeight += addon;
		//this.setState({heightAddon:addon,heightAddonDiffer:addon+this.state.heightAddonDiffer});		
		this.forceUpdate();
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(this.props.moduleInstanceId != moduleInstanceId)
			return;
		let parent = this.props.xml;
		let children = parent.FormItem;
		let has = false;
		for(let i in children)
		{
			let child = children[i];
			if(child.name == name)
			{
				has = true;
				break;
			}
		}
		if(!has)
			return;
		this.forceUpdate();
	}

	componentWillUnmount()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeSwitchTabPageStore();
		}
		this.unsubscribeVerticalSplitterStore();
		this.unsubscribeCmdUpdateControlLabelStore();
		if(typeof(this.unsubscribePopUpDomReadySotre) == "function")
			this.unsubscribePopUpDomReadySotre();
	}

	onSwitchTabPage(arg)
	{
		if(arg.tabName == this.props.xml.name && this.props.moduleInstanceId == arg.moduleInstanceId)
		{
			let parent = this.props.xml;
			let children = parent.FormItem;
			let _intIndex = parseInt(arg.newIndex);

			if(_intIndex<0 || _intIndex>=children.length)
			{
				alert("switchTabPage 未能传入有效的标签页索引");
				return;
			}

			let _newState = {indexes:this.state.indexes,currentIndex:_intIndex};
			if(this.state.currentIndex != _intIndex)
			{
				this.pageChanged = true;
			}
			if(_newState.indexes.indexOf(_intIndex)==-1)
			{
				_newState.indexes.push(_intIndex);
				_newState.renderNewPage = true;
			}
			else
			{

				let lis = $(this.containerComponent).find(">ul>li").removeClass("active");
				if(lis[_newState.currentIndex])
					$(lis[_newState.currentIndex]).addClass("active");

				_newState.renderNewPage = false;
			}
			this.setState(_newState);
			arg.complete = true;
		}
	}

	tabpageOnclick(event)
	{
		//console.log(event);
		
		/*let pageId = $(event.target).attr("href");
		
		let selector = ".tab-content .tab-pane";
		$(selector).hide();
		selector = ".tab-content "+pageId;
		$(selector).css('display','flex');*/
		let _index = $(event.target).attr("data-index");
		let _intIndex = parseInt(_index);

		let _newState = {indexes:this.state.indexes,currentIndex:_intIndex};
		if(this.state.currentIndex != _intIndex)
		{
			this.pageChanged = true;
		}
		if(_newState.indexes.indexOf(_intIndex)==-1)
		{
			_newState.renderNewPage = true;
			_newState.indexes.push(_intIndex);
		}
		else
		{
			_newState.renderNewPage = false;
		}
			
		this.userClickChange = true;
		this.setState(_newState);
		
	}

	componentDidUpdate()
	{
		if(this.pageChanged == true)
		{
			this.pageChanged = false;
			let tabPageXML = this.props.xml.FormItem[this.state.currentIndex];
			//let tabPageName = this.props.xml.FormItem[this.state.currentIndex].name;
			if(this.props.control)
				this.props.control.tabPageChanged(tabPageXML);
		}
		/*
		if(this.userClickChange == true)
		{
			this.userClickChange = false;
			UtilActions.tabpageUserChanged();
		}*/

		if(this.props.forLookup)
		{
			//alert("计算width");
			if(!this.pageWidth)
				this.pageWidth = 0;
			let _pageWidth = this.tabContent.offsetWidth;
			if(_pageWidth>this.pageWidth)
			{
				this.pageWidth = _pageWidth;
			}

			$(this.tabContent).css("width",this.pageWidth+"px");
			this.props.control.module.updatePosition();
		}
	}

	componentWillUpdate()
	{
		if(this.props.forLookup)
			$(this.tabContent).css("width","");
	}

	shouldComponentUpdate(nextProps, nextState)
	{
		return true;
		let pages = $(this.tabContent).find(">.FormItemTabPage");
		if(nextState.renderNewPage)
		{
			//TODO 此处 如果不把现有的都设置为none 则react不会去更新旧的TabPage的样式 不知道为什么
			for(let i = 0;i<pages.length;i++)
			{
				let page = pages[i];
				$(page).css("display","none");
			}
			return true;
		}

		if(nextState.unVisiblePages)
		{
			let lis = $(this.tabLabels).find(">li");
			let nowUnVisiblePagesJson = JSON.stringify(this.state.unVisiblePages);
			let nextUnVisiblePagesJson = JSON.stringify(nextState.unVisiblePages);
			if(nowUnVisiblePagesJson != nextUnVisiblePagesJson)
			{
				for(let i = 0;i<nextState.unVisiblePages.length;i++)
				{
					let _index = nextState.unVisiblePages[i];
					if(_index<lis.length)
					{
						$(lis[_index]).css("display","none");
					}
				}
			}
		}

		

		//let pages = $(this.tabContent).find(">.FormItemTabPage");
		for(let i = 0;i<pages.length;i++)
		{
			let page = pages[i];
			let dataIndex = $(page).attr("data-index");
			dataIndex = parseInt(dataIndex);
			if(dataIndex == nextState.currentIndex)
			//if(i == nextState.currentIndex)
			{
				$(page).css("display","flex");
			}
			else
			{
				$(page).css("display","none");
			}
		}

		if(nextState.currentIndex == this.state.currentIndex)
			return false;

		if(this.pageChanged == true)
		{
			this.pageChanged = false;
			let tabPageXML = this.props.xml.FormItem[nextState.currentIndex];
			//let tabPageName = this.props.xml.FormItem[nextState.currentIndex].name;
			if(this.props.control)
			{
				let control = this.props.control;
				var _timeoutId = setTimeout(function(){

					clearTimeout(_timeoutId);
					control.tabPageChanged(tabPageXML);
				},
				200);
			}
		}
		if(this.props.forLookup)
		{
			//alert("计算width");
			if(!this.pageWidth)
				this.pageWidth = 0;
			let _pageWidth = this.tabContent.offsetWidth;
			if(_pageWidth>this.pageWidth)
			{
				this.pageWidth = _pageWidth;
			}

			$(this.tabContent).css("width",this.pageWidth+"px");
			this.props.control.module.updatePosition();
		}

		//this.state = nextState;

		return false;
	}

	getTabPages()
	{
		let result = {pages:[],contents:[]};
		let parent = this.props.xml;
		let children = parent.FormItem;
		let layout = parent.Properties.Layout.Value;
		let index = 0;
		let unVisiblePages = this.state.unVisiblePages;
		for(let i in children)
		{
			let current = (index == this.state.currentIndex);
			let _className = current?"active":"";
			let _visible = unVisiblePages.indexOf(index)!=-1?false:current;
			
			//index>0?false:true;
			let child = children[i];
			let tabPageControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,child.id),
				this.props.forLookup);
			let childLabel = tabPageControl._cmdLabel?tabPageControl._cmdLabel:tabPageControl.getProperty_Label();//child.name;
			let pageName = "#"+child.id;
			// let pageStyle = {textAlign: 'center',cursor: 'pointer',boxSizing: 'content-box',position:'relative',margin:'0px',paddingTop:'2px',border: 'none',borderBottom: '1px solid rgb(204,204,204)'};
			let pageStyle = {textAlign: 'center',cursor: 'pointer',boxSizing: 'content-box',position:'relative',margin:'0px',paddingTop:'2px',border: 'none'};
			if(unVisiblePages.indexOf(index)!=-1)
			{
				pageStyle.display = "none";
				_className = "no-active-"+_visible;
			}

			result.pages.push(
			<li data-index={i} className={_className} style={pageStyle} onClick={this.tabpageOnclick.bind(this)} key={"li"+child.id}>
				{/* <div  style={{position:'absolute',top:'0px',right:'-6.5px',width:0,height:0,borderColor: 'transparent #fff',borderWidth:'0 15px 25px 0',borderStyle: 'solid'}}>
                	<div  style={{height: '12px',width: '0.5px',backgroundColor: '#ccc',position: 'absolute',transform: 'rotate(-45deg)',transformOrigin: 'left top'}}></div>
					<div  style={{height: '16px',width: '0.5px',backgroundColor: '#ccc',position: 'absolute',top:'7px',left:'8px',transformOrigin: 'left top'}}></div>
				</div> */}
				<a href={pageName} className="gongqi_tabpage" data-index={i} data-toggle="tab" aria-expanded="true" style={{background: 'transparent'}}>
					{childLabel}
				</a>
			</li>);
			
			
			
			if(this.state.indexes.indexOf(index)!=-1)
			{
				/*if(!this.pageHeight)
				{
					if(this.refs["page"+this.state.currentIndex])
						this.pageHeight = $(this.refs["page"+this.state.currentIndex].getPageDiv()).height();
				}heightFromTab={this.pageHeight-3}*/ 
				result.contents.push(<FormItemTabPage xmlChildIndex={i} control={tabPageControl} menuItemId={this.props.menuItemId} formId={this.props.formId} ref={"page"+index} visible={_visible} key={child.id} xml={child} parentLayout={layout} forLookup={this.props.forLookup} contextMenuData={this.props.contextMenuData}/>);
			}
			index++;
		}
		return result;
		
	}

	componentDidMount()
	{
		//console.log(this.refs["page"+this.state.currentIndex].getPageDiv());
		//TODO 当画面存在radio时候 datagrid自动计算高度 由于Tabpage存在height导致计算不准确    故 先去掉
		// 之前为什么加上 已经遗忘
		if(!this.pageHeight)
		{
			setTimeout(this.laterSetFixedPageHeight.bind(this),100); 
		}
		//alert(this.pageHeight);
	}

	laterSetFixedPageHeight()
	{
		//TODO 当画面存在radio时候 datagrid自动计算高度 由于Tabpage存在height导致计算不准确    故 先去掉
		// 之前为什么加上 已经遗忘
		// this.pageHeight = this.tabContent.offsetHeight;
		// if(this.props.forLookup)
		// {
		// 	if(this.pageHeight && this.pageHeight>0)
		// 		$(this.tabContent).css("height",this.pageHeight+"px");
		// }
		// else
		// {
		// 	$(this.tabContent).css("height",this.pageHeight+"px");
		// }

		if(this.props.forLookup)
		{
			//alert("计算width");
			if(!this.pageWidth)
				this.pageWidth = 0;
			let _pageWidth = this.tabContent.offsetWidth;
			if(_pageWidth>this.pageWidth)
			{
				this.pageWidth = _pageWidth;
				$(this.tabContent).css("width",this.pageWidth+"px");
			}
		}

		//alert("初始pageHeight"+this.pageHeight);
	}

	getStyle()
	{
		//对于Tab本身没有任何布局 所以只关心父级布局情况
		let parentLayout = this.props.parentLayout;
		//本身固定布局为flex 纵向 因为要布局下面的标签选项卡与内容区域 内容区域填充剩余空间
		let style = {
		  	display:'flex',
		  	flexDirection:'column'
	    };
		
		//如果设置了Width或者Height属性 则按照属性设置 否则为百分百 与Flex版框架保持一致	   
		//但是存在其余控件包含tab而设置成百分百的情况 此情况在Flex版框架中也没有考虑 但是在实际
		//使用过程中并未提出此问题 所以暂不考虑
	    
	    if(parentLayout == "horizontal")
	    {
	    	//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
	    	//alert(json);
	    	let _width = this.props.xml.Properties.Width.Value;
	    	if(_width == undefined)
	    		_width = "";
			let flexGrow = 0;
			let fixedWidth = false;
			if(_width == "")
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _width.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _width.substring(0,iex);
				}
				
				if(iex==-1&&_width != "")
				{
					flexGrow = _width+"px";
					fixedWidth = true;
				}	
			}
			
			if(!fixedWidth)style["flexGrow"] = flexGrow; 

			let _height = this.props.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";
			if(_height == "")
				_height = "100%";
			if(_height == "100%" && !window.isPopUp && !window.isLookup)
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.props.xml.Properties.Height.Value;
	    	if(_height==undefined)
	    		_height = "";
			let flexGrow = 0;
			let fixedHeight = false;
			if(_height == "")
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _height.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _height.substring(0,iex);
				}
				if(iex==-1&&_height != "")
				{
					flexGrow = _height+"px";
					fixedHeight = true;
				}	
			}
			
			if(!fixedHeight)style["flexGrow"] = flexGrow; 

			let _width = this.props.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "")
				_width = "100%";
			if(_width == "100%" && !window.isPopUp && !window.isLookup)
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
	    }
		
		return style;
	}

	onCmdUpdateControlVisible(menuItemId,formId,names,isLookup)
	{
		//return;
		if(this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId
			&& this.props.formId == formId)
		{
			
			if(names.indexOf(this.props.xml.name)!=-1)
			{
				let finalVisible = this.props.control.getProperty_Visible_Final();
				this.setState({visible:finalVisible});	
			}
			let parent = this.props.xml;
			let children = parent.FormItem;
			let unVisiblePages = this.state.unVisiblePages.concat();
			let deal = false;
			for(let i = 0;i<children.length;i++)
			{
				let child = children[i];
				//只更改可见性经过二次开发命令设置过的
				if(names.indexOf(child.name)!=-1)
				{
					deal = true;
					let tabPageControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(this.props.menuItemId,this.props.formId,child.id),this.props.forLookup);
					let _visible = tabPageControl.getProperty_Visible_Final();
					if(!_visible && unVisiblePages.indexOf(i) == -1)
					{
						unVisiblePages.push(i);
					}
					else if(_visible)
					{
						let index = unVisiblePages.indexOf(i);
						if(index != -1)
							unVisiblePages.splice(index,1);
					}
				}
				
			}
			if(!deal)
				return;
			let currentIndex = this.state.currentIndex;
			let currentIndexBak = currentIndex;
			while(unVisiblePages.indexOf(currentIndex)!=-1)
			{
				currentIndex++;
				if(currentIndex>children.length-1)
				{
					currentIndex = 0;
				}
				if(currentIndex == currentIndexBak)
				{
					break;
					/*alert("GOT设置或二次开发逻辑导致无可显示的TabPage");
					this.setState({unVisiblePages:unVisiblePages});
					return;*/
				}
			}
			let indexes = this.state.indexes;
			let renderNewPage = false;
			if(indexes.indexOf(currentIndex) == -1)
			{
				indexes.push(currentIndex);renderNewPage = true;
			}
			this.state.unVisiblePages = unVisiblePages;
			this.setState({unVisiblePages:unVisiblePages,
				currentIndex:currentIndex,indexes:indexes,
				renderNewPage:renderNewPage
			});
			this.forceUpdate();
		}
	}

	//对于tab-content来讲 子节点只有单一显示的tabpane 为了解决chrome浏览器在某一父节点没有采用百分比而子节点
	//设置height为百分比不起作用的问题 所以tab-content采用flex布局 并且子节点全部延伸
	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		_style["marginBottom"] = 0;
		let _content = this.getTabPages();
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";

		let _contentStyle = {display:'flex',alignItems:'stretch',flexGrow:100,border:'solid 1px #ccc',borderTop:'none'};
		if(this.pageHeight)
			_contentStyle.height = this.pageHeight+'px';
		return(
			<div id={this.props.xml.name} data-xmlid={this.props.xml.id} className = "FormItemTab nav-tabs-custom" ref={node => this.containerComponent = node} style={_style}>
				<ul className = "nav nav-tabs" ref={node=>this.tabLabels=node} style={{marginBottom:'0px',display:'flex'}}>
					{_content.pages}
					<div style={{flexGrow:'1',borderBottom:'1px solid rgb(205,205,205)'}}></div>
				</ul>
				<div className = "tab-content" ref={node=>this.tabContent=node} style={_contentStyle}>
		            {_content.contents}
				</div>
			</div>
		);
	}
};

FormItemTab.defaultProps = {
};

export default FormItemTab;


// WEBPACK FOOTER //
// ./src/formItem/FormItemTab.js